import { Container, Row, Col } from '@geberit/gdds';

// styles
import styles from '../text-image.module.scss';

// types
import type { LeftRightSmallProps } from '..';

// components
import { Mobile, Tablet } from 'components/breakpoints';

// utils
import { contentHeadline } from '..';
import { buildSize, gridSizes } from 'utils/gridSize';
import { classNameBuilder } from 'utils/classNameBuilder';

export function LeftRightSmall({
  image: Image,
  headline: Headline,
  caption: Caption,
  content: Content,
  link: Link,
  imagePosition,
  theme,
}: Readonly<LeftRightSmallProps>) {
  return (
    <Container maxContentWidth={buildSize(gridSizes.gddsFullGrid)}>
      <Row className={styles.row}>
        <Mobile>
          {(Image || Caption) && (
            <Col
              size={[4, 3, 4]}
              className={classNameBuilder(
                styles.imageWrapper,
                styles['imagePosition-' + imagePosition],
              )}
            >
              {Image && <Image />}
            </Col>
          )}
          <Col size={[4, 5, 8]}>
            {Headline && <Headline className={styles.withMargin} format={contentHeadline[theme]} />}
          </Col>
          {Content && (
            <Col size={[4, 8, 12]}>
              <Content />
            </Col>
          )}
          <Col size={[4, 5, 8]}>{Link && <Link />}</Col>
        </Mobile>
        <Tablet and="desktop">
          <Col size={[4, 5, 8]}>
            {Headline && (
              <Headline className={styles.sublineMargin} format={contentHeadline[theme]} />
            )}
            {Content && <Content />}
            {Link && <Link />}
          </Col>
          {(Image || Caption) && (
            <Col
              size={[4, 3, 4]}
              className={classNameBuilder(
                styles.imageWrapper,
                styles['imagePosition-' + imagePosition],
              )}
            >
              {Image && <Image />}
            </Col>
          )}
        </Tablet>
      </Row>
    </Container>
  );
}
